import React, { useEffect, useRef, useState } from "react";
import { Select } from "antd";
import {
  NavigationSharp,
  ApartmentSharp,
  StoreSharp,
  PostAddSharp,
} from "@mui/icons-material";

const { Option } = Select;

const SearchHeader = ({
  setReset,
  setSelectedCountryData,
  country,
  setSelectedCity,
  city,
  setSelectedCompanyData,
  companyList,
  setSelectedDesignationData,
  designationList,
}) => {
  // Convert data to options format for Ant Design Select
  const countryOptions = country?.map((val) => ({
    label: `${val.name} (${val.itemCounts})`,
    value: val.id,
  }));
  const cityOptions = city?.map((val) => ({
    label: `${val.name} (${val.itemCounts})`,
    value: val.id,
  }));
  const companyListOptions = companyList?.map((val) => ({
    label: `${val.name} (${val.itemCounts})`,
    value: val.id,
  }));
  const designationListOptions = designationList?.map((val) => ({
    label: `${val.name} (${val.itemCounts})`,
    value: val.id,
  }));

  // Handlers
  const handleChange = (setter) => (value) => {
    setReset(true);
    setter(value);
  };

  return (
    <div className="d-block d-md-flex jobSearch jobdropdown mb-2">
      <div className="col-md-3 mb-1">
        <div className="searchInput d-flex align-items-center p-2">
          <NavigationSharp className="material-symbols-sharp me-1" />
          <Select
            mode="multiple"
            allowClear
            style={{ width: "100%",borderRadius : "0" }}
            placeholder="Select Country"
            options={countryOptions}
            onChange={handleChange(setSelectedCountryData)}
          />
        </div>
      </div>
      <div className="col-md-3 mb-1">
        <div className="searchInput d-flex align-items-center p-2">
          <ApartmentSharp className="material-symbols-sharp me-2" />
          <Select
            mode="multiple"
            allowClear
            style={{ width: "100%",borderRadius : "0" }}
            placeholder="Select City"
            options={cityOptions}
            onChange={handleChange(setSelectedCity)}
          />
        </div>
      </div>
      <div className="col-md-3 mb-1">
        <div className="searchInput d-flex align-items-center p-2">
          <StoreSharp className="material-symbols-sharp me-2" />
          <Select
            mode="multiple"
            allowClear
            style={{ width: "100%", borderRadius : "0" }}
            placeholder="Select Company"
            options={companyListOptions}
            onChange={handleChange(setSelectedCompanyData)}
          />
        </div>
      </div>
      <div className="col-md-3 mb-1">
        <div className="searchInput d-flex align-items-center p-2">
          <PostAddSharp className="material-symbols-sharp me-2" />
          <Select
            mode="multiple"
            allowClear
            style={{ width: "100%" , borderRadius : "0"}}
            placeholder="Select Designation"
            options={designationListOptions}
            onChange={handleChange(setSelectedDesignationData)}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchHeader;
